import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { logEvent } from '@eventbrite/statsig';
import {
    GA_HOME_CATEGORY,
    GA_HOME_FEED_CATEGORY,
    GA_VIEW_HOMEPAGE_FEED,
    GA_VIEW_LOGGEDOUT_HOMEPAGE_FEED,
} from '../../../constants/analytics';
import { HomeEngagementExperimentTrackingLocations } from '../constants/analytics';

// This is mainly here because on the feed we want to track extra stuff
// on componentDidMount in addition to the pageview we already are tracking,
// and we want to keep it consistent where the category will be different depending
// on logged-in or logged-out status.
export const getFeedTrackingProperties = (
    isAuthenticated?: boolean,
    userId?: string,
) => {
    // Non-auth'd users, Category is "home"
    let category = GA_HOME_CATEGORY;

    let action = GA_VIEW_LOGGEDOUT_HOMEPAGE_FEED;

    let dimensions = {};

    // Auth'd users, Category is "home-feed"
    if (isAuthenticated) {
        category = GA_HOME_FEED_CATEGORY;
        action = GA_VIEW_HOMEPAGE_FEED;
        dimensions = { userId };
    }

    return {
        category,
        action,
        nonInteraction: true,
        dimensions,
    };
};

export const logToStatsigHomeEngagement = (
    location: HomeEngagementExperimentTrackingLocations,
    isAuthenticated: boolean,
) => {
    if (HAS_WINDOW) {
        const isMobile = window.innerWidth < 600;
        const statsigLoggingString = getHomeEngagementEventString({
            locationKey: location,
            isMobile,
            isAuthenticated,
        });

        logEvent(statsigLoggingString);
    }
};

type DeviceFormat = 'Mobile' | 'Desktop';
type AuthenticatedStatus = 'Logged In' | 'Logged Out';
type HomeEngagementTrackingString =
    `Home - Click - ${HomeEngagementExperimentTrackingLocations} - ${DeviceFormat} - ${AuthenticatedStatus}`;

interface IGetHomeEngagementEventString {
    locationKey: HomeEngagementExperimentTrackingLocations;
    isAuthenticated: boolean;
    isMobile: boolean;
}

export const getHomeEngagementEventString = (
    params: IGetHomeEngagementEventString,
): HomeEngagementTrackingString => {
    const isMobile = params.isMobile ? 'Mobile' : 'Desktop';
    const isAuthenticated = params.isAuthenticated ? 'Logged In' : 'Logged Out';
    const locationString: HomeEngagementTrackingString = `Home - Click - ${params.locationKey} - ${isMobile} - ${isAuthenticated}`;

    return locationString;
};
